import Url from 'url-parse';
import queryString from 'query-string';

import store from '../../configureStore';
import { triggerCampaign } from './redux/actions';

const { dispatch } = store.store;

/**
 * Action map
 */
const acts = {
  leave: () => {
    // dispatch(setCampaignInfo({}));
    // dispatch(setHasActiveCampaign(false));
    dispatch(triggerCampaign(false));
  },
  active: () => {
    // dispatch(
    //   setHasActiveCampaign(status !== 'false')
    // );
  }
};

/**
 * Handle action
 * @param {*} url
 */
const handleAction = (url) => {
  // Get actions and parameters if available
  const [actions, parameters] = parseUrl(url);

  // Do actions
  for (let i = 0; i < actions.length; i += 1) {
    if (acts[actions[i]]) {
      acts[actions[i]](parameters);
    }
  }
};

/**
 * @private
 * @returns Array of actions and parameters
 */
const parseUrl = (url) => {
  const parsedUrl = new Url(url);
  const actionArray = parsedUrl.pathname.split('/');

  // Get actions from path
  const actions = actionArray[actionArray.length - 1].split('-');

  // Get parameters from queryString
  const parameters = queryString.parse(parsedUrl.query);

  // Travel safe
  return [actions, parameters];
};

export default handleAction;
